<template>
  <div>
    <Chart :options="chartOptions"></Chart>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import more from "highcharts/highcharts-more";
import { computed, toRefs } from "vue";
more(Highcharts);

export default {
  components: { Chart },
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
    titleText: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "bar",
    },
    colors: {
      type: Array,
      default: () => ["#0085FF", "#FDAB3D"],
    },
    plotOptionsColumn: {
      type: Object,
      default: () => {
        return {
          dataLabels: {
            enabled: false,
            format: "{point.y:.1f}%",
          },
          pointWidth: 40,
        };
      },
    },
    yAxisMax: {
      type: Number,
      default: 100,
    },
    yAxisFormat: {
      type: String,
      default: "",
    },
    yAxisTitleText: {
      type: String,
      default: "",
    },
    xAxisTitleText: {
      type: String,
      default: "",
    },
    chartHeight: {
      type: Number,
      default: 300,
    },
    hasTooltip: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    // generate props data
    const {
      labels,
      series,
      titleText,
      type,
      colors,
      plotOptionsColumn,
      yAxisMax,
      yAxisFormat,
      yAxisTitleText,
      xAxisTitleText,
      chartHeight,
      hasTooltip,
    } = toRefs(props);

    const chartOptions = computed(() => {
      return {
        chart: {
          style: {
            fontFamily: "iranyekan",
          },
          type: type.value,
          height: chartHeight.value, // set maximum height to 500 pixels
        },
        colors: colors.value,
        title: {
          text: titleText.value,
          align: "right",
        },
        subtitle: {
          text: "",
          align: "right",
        },
        xAxis: {
          categories: labels.value,
          title: {
            text: xAxisTitleText.value,
          },
        },
        yAxis: {
          tickInterval: 10,
          min: 0,
          max: yAxisMax.value,
          title: {
            text: yAxisTitleText.value,
            align: "high",
          },
          labels: {
            overflow: "justify",
            format: yAxisFormat.value,
          },
        },
        tooltip: {
          valueSuffix: "",
          enabled: hasTooltip.value,
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
            pointWidth: 40, // set the width of the columns
          },
          column: plotOptionsColumn.value,
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "top",
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
          shadow: true,
        },
        credits: {
          enabled: false,
        },
        series: series.value,
      };
    });

    // return data to be used in template
    return { chartOptions };
  },
};
</script>
